import { useEffect, useRef, useState } from 'react';

import Header from '../../components/Header/Header';

import MainBlock from './HomeBlocks/MainBlock';
import HowWeWorkBlock from './HomeBlocks/HowWeWorkBlock';
import ServicesBlock from './HomeBlocks/ServicesBlock';
import WhoWeWorkWithBlock from './HomeBlocks/WhoWeWorkWithBlock';
import WhyUsBlock from './HomeBlocks/WhyUsBlock';
import FormBlock from './HomeBlocks/FormBlock';
import QuestionsBlock from './HomeBlocks/QuestionsBlock';
import FeedbacksBlock from './HomeBlocks/FeedbacksBlock';


import Footer from '../../components/Footer/Footer';


import './HomePage.css';

export default function HomePage() {
  const headerRef = useRef(null);
  const servicesRef = useRef(null); // ServicesBlock
  const howWeWorkDesktopRef = useRef(null); // HowWeWorkBlock
  const howWeWorkMobileRef = useRef(null);
  const whoWeWorkWithRef = useRef(null); // WhoWeWorkWithBlock
  const whyUsRef = useRef(null); // WhyUsBlock
  const projectsRef = useRef(null); // ProjectsBlock
  const questionsRef = useRef(null); // QuestionsBlock
  const feedbacksRef = useRef(null); // FeedbacksBlock
  const formRef = useRef(null); // FormBlock




  const [activeHeaderKey, setActiveHeaderKey] = useState('header');

  useEffect(() => {
    let rafId = null;
    let debounceId = null;

    const computeActiveSection = () => {
      const viewportCenter = window.innerHeight / 2;
      const candidates = [
        ['header', headerRef.current],
        ['services', servicesRef.current],
        ['howWeWork', (howWeWorkDesktopRef.current || howWeWorkMobileRef.current)],
        ['whoWeWorkWith', whoWeWorkWithRef.current],
        ['whyUs', whyUsRef.current],
        // ['projects', projectsRef.current],
        ['questions', questionsRef.current],
        ['feedbacks', feedbacksRef.current],

      ].filter(([, el]) => !!el);

      let bestKey = 'header';
      let bestDistance = Number.POSITIVE_INFINITY;
      for (const [key, el] of candidates) {
        const rect = el.getBoundingClientRect();
        const sectionCenter = rect.top + rect.height / 2;
        const distance = Math.abs(sectionCenter - viewportCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestKey = key;
        }
      }
      setActiveHeaderKey(bestKey);
    };

    const onScrollOrResize = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        if (debounceId) clearTimeout(debounceId);
        debounceId = setTimeout(computeActiveSection, 150);
      });
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    computeActiveSection();

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (debounceId) clearTimeout(debounceId);
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    };
  }, []);

  const scrollTo = (ref) => {
  if (ref.current) {
    const topOffset = ref.current.getBoundingClientRect().top + window.pageYOffset - 100;

    window.scrollTo({
      top: topOffset,
      behavior: 'smooth',
    });
  }
};

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100dvh',
        backgroundColor: 'rgba(250, 253, 255, 1)',
      }}
    >
      <Header
        onScrollTo={{
          header: () => scrollTo(headerRef),
          services: () => scrollTo(servicesRef),
          howWeWork: () => scrollTo(howWeWorkDesktopRef, howWeWorkMobileRef),
          whoWeWorkWith: () => scrollTo(whoWeWorkWithRef),
          whyUs: () => scrollTo(whyUsRef),
          projects: () => scrollTo(projectsRef),
          questions: () => scrollTo(questionsRef),
          feedbacks: () => scrollTo(feedbacksRef),
          form: () => scrollTo(formRef),

        }}
        activeKey={activeHeaderKey}
      />
      <MainBlock scrollToRef={headerRef} onScrollTo={{
        projects: () => scrollTo(projectsRef),
        feedbacks: () => scrollTo(feedbacksRef),
      }} />
      <ServicesBlock scrollToRef={servicesRef} scrollToMobileRef={howWeWorkMobileRef} />
      <HowWeWorkBlock scrollToRef={howWeWorkDesktopRef} />
      <WhoWeWorkWithBlock scrollToRef={whoWeWorkWithRef} />
      <WhyUsBlock scrollToRef={whyUsRef} />
      {/* <ProjectsBlock scrollToRef={projectsRef} /> */}
      <QuestionsBlock scrollToRef={questionsRef} />
      <FeedbacksBlock scrollToRef={feedbacksRef} />
      <FormBlock scrollToRef={formRef} />
      <Footer
        onScrollTo={{
          services: () => scrollTo(servicesRef),
          howWeWork: () => scrollTo(howWeWorkDesktopRef, howWeWorkMobileRef),
          whoWeWorkWith: () => scrollTo(whoWeWorkWithRef),
          whyUs: () => scrollTo(whyUsRef),
          projects: () => scrollTo(projectsRef),
          questions: () => scrollTo(questionsRef),
          feedbacks: () => scrollTo(feedbacksRef),
          form: () => scrollTo(formRef),

        }}
      />
    </div>
  );
}
